export default __webpack_public_path__ + "static/media/upland.fde0f95e.webp";